import React from "react";
import { COST_ROWS } from "../../data/content";
export function CostOfInaction() {
  return <section className="bg-black py-16 px-4" data-id="element-54" data-mp="2qt58lfdlrws8">
      <div className="max-w-4xl mx-auto" data-id="element-55" data-mp="2qtex0yj01vvt">
        <h2 className="font-display text-3xl sm:text-5xl text-white text-center uppercase mb-2" data-id="element-56" data-mp="2ltit0zaay4g9">
          ⚖️ ¿Cuánto cuesta <span className="text-[#e10600]" data-id="element-57" data-mp="2gv7lwwbe681q">no tenerlo?</span>
        </h2>
        <p className="text-center text-neutral-500 text-sm mb-8 md:hidden" data-id="element-58" data-mp="2ct44lr21k98j">← Deslizá para ver la tabla completa →</p>

        <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-neutral-800" data-id="element-59" data-mp="281ui2zbshm0v">
          <table className="w-full min-w-[560px] text-sm" data-id="element-60" data-mp="2331bzryu0xaq">
            <thead data-id="element-61" data-mp="233kp8vdjexif">
              <tr className="bg-neutral-950 text-left" data-id="element-62" data-mp="1y480g533vgd7">
                <th className="p-4 font-condensed text-lg text-white tracking-wide" data-id="element-63" data-mp="1y5j66ag42y6y">Sin Megapack 72hs™</th>
                <th className="p-4 font-condensed text-lg text-[#e10600] tracking-wide" data-id="element-64" data-mp="1t4los02xe86i">Costo real</th>
              </tr>
            </thead>
            <tbody data-id="element-65" data-mp="md74bmn0g9hy">
              {COST_ROWS.map((r, i) => <tr key={i} className={i % 2 ? "bg-black" : "bg-neutral-950/50"} data-id="element-66" data-mp="mcfbukopmrvw" data-mpi={i}>
                  <td className="p-4 text-neutral-300 align-top" data-id="element-67" data-mp="r47738it9lsd">{r.action}</td>
                  <td className="p-4 text-neutral-400 align-top" data-id="element-68" data-mp="cfjbx3cvne2y">{r.cost}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-10" data-id="element-69" data-mp="henmnyfg9jve">
          <p className="font-display text-2xl sm:text-3xl text-white uppercase" data-id="element-70" data-mp="153ydoo6zzzwc">
            La próxima semana puede ser diferente.
          </p>
          <blockquote className="mt-6 font-condensed text-xl sm:text-2xl text-neutral-300 tracking-wide max-w-2xl mx-auto" data-id="element-71" data-mp="1a29n4xtds8e1">
            "Tu cocina ya tiene todo lo que necesitás para empezar. El sistema es lo único que
            faltaba." 🍕
          </blockquote>
        </div>
      </div>
    </section>;
}